import React from "react";

interface SidebarContextValue {
  expanded: boolean;
  toggleSidebar: () => void;
}

const STORAGE_KEY = "tlx-sidebar-expanded";

const SidebarContext = React.createContext<SidebarContextValue | null>(null);

export const SidebarProvider: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => {
  const [expanded, setExpanded] = React.useState(() => {
    const stored = localStorage.getItem(STORAGE_KEY);
    return stored !== null ? stored === "true" : false;
  });

  const toggleSidebar = React.useCallback(() => {
    setExpanded(prev => {
      const next = !prev;
      localStorage.setItem(STORAGE_KEY, String(next));
      return next;
    });
  }, []);

  const value = React.useMemo(
    () => ({ expanded, toggleSidebar }),
    [expanded, toggleSidebar],
  );

  return (
    <SidebarContext.Provider value={value}>{children}</SidebarContext.Provider>
  );
};

export const useSidebarContext = () => {
  const ctx = React.useContext(SidebarContext);
  if (!ctx)
    throw new Error("useSidebarContext must be used within SidebarProvider");
  return ctx;
};
